import React, { useEffect, useState } from 'react';
import { Dropdown } from 'antd';
import { DownOutlined, CheckOutlined, PlusOutlined } from '@ant-design/icons';
import { listTeams } from './teamsApi';
import CreateTeamModal from './CreateTeamModal';
import './teams.css';

const COLORS = ['#5039BB', '#1D9E75', '#D85A30', '#D4537E', '#185FA5'];
const initials = (s) => (s || 'T').slice(0, 2).toUpperCase();

// Team switcher for the sidebar: lists the user's teams (shown as "Teams"),
// marks the current one, and opens the Create a team modal.
const TeamSwitcher = ({ wId, onSelect }) => {
  const [teams, setTeams] = useState([]);
  const [currentId, setCurrentId] = useState(localStorage.getItem('currentTeamId'));
  const [modal, setModal] = useState(false);
  const [open, setOpen] = useState(false);

  // Persist the selected team + whether it's the default ("General") team, so
  // other pages (Check-ins/Projects/Reports) can scope their queries.
  const persist = (team) => {
    localStorage.setItem('currentTeamId', team._id);
    localStorage.setItem('currentTeamIsDefault', team.is_default ? 'true' : 'false');
  };

  const load = () =>
    listTeams(wId)
      .then((res) => {
        if (res.data && res.data.success) {
          const list = res.data.teams || [];
          setTeams(list);
          const savedId = localStorage.getItem('currentTeamId');
          const saved = list.find((t) => t._id === savedId);
          if (saved) {
            persist(saved); // refresh is_default in case it changed
          } else if (list[0]) {
            setCurrentId(list[0]._id);
            persist(list[0]);
          }
        }
      })
      .catch(() => {});

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wId]);

  const select = (team) => {
    setCurrentId(team._id);
    persist(team);
    setOpen(false);
    if (onSelect) onSelect(team);
  };

  const current = teams.find((s) => s._id === currentId) || teams[0];

  const menu = (
    <div className="tpr-switcher">
      <div className="tpr-switcher__head">Your teams</div>
      {teams.map((s, i) => (
        <div key={s._id} className="tpr-switcher__item" onClick={() => select(s)}>
          <span className="tpr-switcher__avatar" style={{ background: COLORS[i % COLORS.length] }}>
            {initials(s.name)}
          </span>
          <span className="tpr-switcher__name">{s.name}</span>
          {current && s._id === current._id && <CheckOutlined className="tpr-switcher__check" />}
        </div>
      ))}
      <div
        className="tpr-switcher__create"
        onClick={() => {
          setOpen(false);
          setModal(true);
        }}
      >
        <PlusOutlined /> Create a team
      </div>
    </div>
  );

  return (
    <>
      <Dropdown
        overlay={menu}
        trigger={['click']}
        visible={open}
        onVisibleChange={setOpen}
        placement="bottomLeft"
      >
        <div
          className="tpr-switch-row"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 11,
            padding: '8px',
            cursor: 'pointer',
            background: 'transparent',
            borderRadius: 12,
            margin: '4px 8px',
          }}
        >
          <span
            className="tpr-switcher__avatar"
            style={{
              background: '#6d44d9',
              width: 34,
              height: 34,
              borderRadius: 10,
              fontSize: 13,
              fontWeight: 700,
              flex: 'none',
            }}
          >
            {initials(current && current.name)}
          </span>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ color: '#eef2f7', fontWeight: 600, fontSize: 14.5 }}>
              {current ? current.name : 'No team yet'}
            </div>
            <div style={{ color: '#8395ab', fontSize: 12 }}>
              {current && current.default_channel && current.default_channel.name
                ? `#${current.default_channel.name}`
                : 'Create a team'}
            </div>
          </div>
          <DownOutlined style={{ color: '#6b7e96', fontSize: 16 }} />
        </div>
      </Dropdown>

      <CreateTeamModal
        wId={wId}
        visible={modal}
        onClose={() => setModal(false)}
        onCreated={(team) => {
          setModal(false);
          load();
          if (team) select(team);
        }}
      />
    </>
  );
};

export default TeamSwitcher;
